/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bidbattle__Status__Live4Inputs */

const en_bidbattle__status__live4 = /** @type {(inputs: Bidbattle__Status__Live4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

/**
* | output |
* | --- |
* | "Live" |
*
* @param {Bidbattle__Status__Live4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const bidbattle__status__live4 = /** @type {((inputs?: Bidbattle__Status__Live4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bidbattle__Status__Live4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bidbattle__status__live4(inputs)
});
export { bidbattle__status__live4 as "bidbattle__status__LIVE" }